import styled from '@emotion/styled';
import Typography from 'aquilla/core/atoms/Typography';
import { Spacings, mediaQuery, Fonts } from '@styles/index';

const MetricsWrapper = styled.div`
  width: ${Spacings.SPACING_45B};
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    flex-direction: column;
  }
`;

const SubtitleContainer = styled.div`
  color: var(--color-i-gray-13);
  font-size: ${Fonts.H6};
  font-weight: ${Fonts.LIGHT};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H7};
  }
`;

const HeadingMetrics = ({ text, subtext }) => {
  return (
    <>
      <MetricsWrapper>
        <Typography variant="h3" color="var(--color-i-black)">
          {text}
        </Typography>
        <SubtitleContainer>{subtext}</SubtitleContainer>
      </MetricsWrapper>
    </>
  );
};

export default HeadingMetrics;
